<template>
  <div>
    <div class="top-window between between-center">
      <div class="heading1 heading1-line">
        Заказ №{{context.orderId}}
      </div>
    </div>
    <div class="files-list">
      <div class="text text-mb8">
        <strong v-if="context.isClient" >Файлы клиники </strong>
        <strong v-else>Файлы лабаратории</strong>
        <span class="text-secondary">
          <strong>{{context.files.length}}</strong>
        </span><br>
      </div>
      <div class="files-grid">
        <a
          v-for="file in files"
          :key="file.id"
          class="file-attached w-inline-block"
        >
          <div class="file-info">
            <div class="file-title">
              {{file.name}}
            </div>
            <div class="file-info-bottom">
              <div class="text-secondary">
                {{date(file)}}
              </div>
              <div class="text-secondary text-secondary-ml8">
                {{file.size}} Мб
              </div>
            </div>
          </div>
          <div class="icon-btn">
            <a
              class="icon-16px w-embed"
              :download="file.name"
              :href="file.file"
            >
              <DownloadIcon />
            </a>
          </div>
        </a>
      </div>
      <UploadModels
        v-if="role === 'client' && !['rejected', 'completed'].includes(context.tab)"
        :isUpdate="true"
        :isLab="false"
        :orderId="context.orderId"
        @update="updateFiles($event)"
      />
    </div>
  </div>
</template>

<script>
  import DownloadIcon from '@/icons/download.svg';
  import formatDate from '@/utils/formatting/format-date';
  import {mapState, mapActions} from 'vuex';
  import UploadModels from '../../new-order/UploadModels';

  export default {
    name: 'ClientFilesModal',
    components: {UploadModels, DownloadIcon},
    props: {
      context: {
        type: Object,
        default: () => ({
          files: null,
        }),
      },
    },
    data () {
      return {
        files: this.context.files,
      };
    },
    created() {
    },
    computed: {
      ...mapState({
        role: state => state.auth?.user.role,
      }),
    },
    methods: {
      ...mapActions({
        updateContext: 'modal/updateContext',
      }),
      updateFiles (files) {
        this.files = this.files.concat(files);
        this.updateContext({field: 'isFileUpdateModal', value: true});
        this.$emit('updateFiles', files);
      },
      date (file) {
        return formatDate(file?.created_at);
      },
    },
  };
</script>

<style lang="scss" >
  .file-title, .patient-title, .reason{
    text-overflow: ellipsis;
  }
</style>
